
export const VISIT_NOTES_FIELDS = {
    FORM_NAME: 'name',
    TYPE: 'type',
    SPECIALITY: 'specialties',
    FORM_TYPE: 'formType'
}